/* eslint-disable promise/param-names */
const state = {
  filtersOn:{
      planta: '',
      region: '',
      corp: 1,
      planta_name: '',
      year: '',
      period: '',
      area_f: '',
      sector_f: '',
      machine: '',
      subset: ''
  }
}

const getters = {
  filtersOn: state => state.filtersOn,
}

const mutations = {
    changeFiltersOn(state, payload){
        let key = null;
        for (key in payload) {
          localStorage.setItem(key + '_on', payload[key])
        }
        state.filtersOn = payload;
    }
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/filtersOn.js